/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
	Button,
	Collapsible,
	Flex,
	IconButton,
	Input,
	Radio,
	Stack,
	Text,
} from '@welbe/design-system';
import { FilterPopover } from 'App/Components/FilterPopover/FilterPopover';
import { useRef, useState } from 'react';
import { LuFilter, LuSearch } from 'react-icons/lu';
import { handleKeyPress } from 'utils/keyPressHandler';

const statusOptions = [
	{ id: 'active', name: 'Activo' },
	{ id: 'pendent', name: 'Pendiente' },
	{ id: 'disabled', name: 'Desactivado' },
];

type AdminFilterProps = {
	filters: Record<string, any>;
	onChangeFilters: (filter: { [key: string]: any }) => void;
	onSearch: (payload?: Record<string, any>) => void;
};

export const AdminFilters = ({
	filters,
	onChangeFilters,
	onSearch,
}: AdminFilterProps) => {
	const [isOpen, setOpen] = useState(false);
	const inputFilterName = useRef<HTMLInputElement>(null);

	const handleChangeName = () => {
		const name = inputFilterName.current?.value || '';
		onChangeFilters({ name });
		onSearch({ ...filters, name });
	};

	return (
		<Flex direction="column" gap="16px" pb="20px" width="100%">
			<Collapsible.Root
				width="100%"
				onOpenChange={({ open }: { open: boolean }) => setOpen(open)}
			>
				<Flex gap="8px" align="flex-end">
					<Collapsible.Trigger asChild>
						<IconButton
							variant={isOpen ? 'solid' : 'subtle'}
							size="xs"
							aria-label="Filtros"
						>
							<LuFilter />
						</IconButton>
					</Collapsible.Trigger>

					<Input
						size="xs"
						placeholder="Busca por nombre del médico"
						width="100%"
						ref={inputFilterName}
						onKeyDown={(e) => handleKeyPress(e, handleChangeName)}
					/>

					<Button
						colorPalette="blue"
						size="xs"
						onClick={handleChangeName}
						flexShrink={0}
					>
						<LuSearch size={14} />
						Buscar
					</Button>
				</Flex>

				<Collapsible.Content>
					<Flex gap="8px" flexWrap="wrap" align="flex-end" mt="12px">
						<FilterPopover
							label="Estatus"
							hasValue={!!filters.status}
							onClear={() => onChangeFilters({ status: '' })}
							displayValue={
								statusOptions.find((option) => option.id === filters.status)
									?.name || ''
							}
						>
							<Text fontSize="sm" fontWeight="500" mb="2">
								Estatus
							</Text>
							<Radio.Root
								size="sm"
								value={filters.status || ''}
								onValueChange={(details: { value: string }) => {
									onChangeFilters({ status: details.value });
								}}
							>
								<Stack gap="2">
									{statusOptions.map((option) => (
										// @ts-ignore
										<Radio.Item key={option.id} value={option.id}>
											<Radio.ItemHiddenInput />
											<Radio.ItemIndicator />
											<Radio.ItemText>{option.name}</Radio.ItemText>
										</Radio.Item>
									))}
								</Stack>
							</Radio.Root>
						</FilterPopover>
					</Flex>
				</Collapsible.Content>
			</Collapsible.Root>
		</Flex>
	);
};
